import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MarketdateStatus } from './marketdate-status.model';
import { MarketdateStatusService } from './marketdate-status.service';
@Injectable()
export class MarketdateStatusPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private marketdateStatusService: MarketdateStatusService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketdateStatusService.find(id).subscribe((marketdateStatus) => {
                marketdateStatus.updated = this.datePipe
                    .transform(marketdateStatus.updated, 'yyyy-MM-ddThh:mm');
                marketdateStatus.created = this.datePipe
                    .transform(marketdateStatus.created, 'yyyy-MM-ddThh:mm');
                this.marketdateStatusModalRef(component, marketdateStatus);
            });
        } else {
            return this.marketdateStatusModalRef(component, new MarketdateStatus());
        }
    }

    marketdateStatusModalRef(component: Component, marketdateStatus: MarketdateStatus): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketdateStatus = marketdateStatus;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status-popup.service.ts